document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description').forEach(function (desc) {
    const fullHTML = desc.innerHTML;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHTML;
    const text = tempDiv.textContent || tempDiv.innerText;

    // Split on sentence endings
    const sentences = text.match(/[^.!?]*[.!?]+/g) || [];
    if (sentences.length <= 2) return; // No need to truncate

    const preview = sentences.slice(0, 2).join(' ').trim();

    desc.innerHTML = `
      <span class="desc-preview">${preview}</span>
      <span class="desc-full" style="display:none">${fullHTML}</span>
      <a href="#" class="desc-toggle" style="display:block; margin-top:8px; font-weight:500;">View more</a>
    `;

    desc.querySelector('.desc-toggle').addEventListener('click', function (e) {
      e.preventDefault();
      desc.querySelector('.desc-preview').style.display = 'none';
      desc.querySelector('.desc-full').style.display = '';
      this.style.display = 'none';
    });
  });
});
